var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useMemo } from "react";
import { useMount, useUpdateEffect } from "react-use";
import useSWR, { useSWRConfig, mutate as globalMutate } from "swr";
export { SWRConfig, useSWRConfig } from "swr";
export function useAspidaSWR(api, method, option) {
    var _this = this;
    var path = useMemo(function () {
        var path = api ? api.$path() : null;
        if (path == null)
            return null;
        if (typeof window === "undefined")
            return path;
        var url = new URL(path, window.location.origin);
        if (option === null || option === void 0 ? void 0 : option.query) {
            for (var _i = 0, _a = Object.entries(option.query); _i < _a.length; _i++) {
                var _b = _a[_i], key = _b[0], value = _b[1];
                if (value == null)
                    continue;
                url.searchParams.append(key, "".concat(value));
            }
        }
        return "".concat(path).concat(url.search);
    }, [api, option === null || option === void 0 ? void 0 : option.query]);
    var fetcher = useMemo(function () {
        if (api == null)
            return null;
        return function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api[method](option)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.body];
                }
            });
        }); };
    }, [api, method, option]);
    var swr = useSWR(path, fetcher, option);
    var cache = useSWRConfig().cache;
    var revalidateIfCacheExists = useCallback(function () {
        if (path == null)
            return;
        var cacheValue = cache.get(path);
        if (cacheValue === undefined || cacheValue.isValidating === true)
            return;
        cache.delete(path);
        swr.mutate();
    }, [cache, path, swr]);
    useMount(function () {
        if ((option === null || option === void 0 ? void 0 : option.disableCache) === true)
            revalidateIfCacheExists();
    });
    useUpdateEffect(function () {
        if ((option === null || option === void 0 ? void 0 : option.disableCache) === true)
            revalidateIfCacheExists();
    }, [option === null || option === void 0 ? void 0 : option.query, option === null || option === void 0 ? void 0 : option.disableCache, path]);
    var removeCacheOfSamePath = useCallback(function (skipCurrentKey) { return __awaiter(_this, void 0, void 0, function () {
        var apiPath, deleteKeys, _i, deleteKeys_1, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(cache instanceof Map) || api == null)
                        return [2 /*return*/];
                    apiPath = api.$path();
                    deleteKeys = Array.from(cache.keys()).filter(function (key) {
                        var basePath = key.split("?")[0];
                        return (apiPath === basePath &&
                            (skipCurrentKey === true ? key !== path : true));
                    });
                    _i = 0, deleteKeys_1 = deleteKeys;
                    _a.label = 1;
                case 1:
                    if (!(_i < deleteKeys_1.length)) return [3 /*break*/, 4];
                    key = deleteKeys_1[_i];
                    cache.delete(key);
                    return [4 /*yield*/, globalMutate(key)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [api, cache, path]);
    var mutate = useCallback(function (data, opts) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof opts === "object" && (opts === null || opts === void 0 ? void 0 : opts.removeOtherCacheOfSamePath) === true)) return [3 /*break*/, 2];
                    // NOTE: globalMutate()と二重にrevalidateされないよう、現在のキーを除外する
                    return [4 /*yield*/, removeCacheOfSamePath(true)];
                case 1:
                    // NOTE: globalMutate()と二重にrevalidateされないよう、現在のキーを除外する
                    _a.sent();
                    _a.label = 2;
                case 2:
                    // NOTE: mutate()と呼び出した場合、dataがundefinedになるため、引数なしでmutate()を呼び出さないと{data:undefined}としてキャッシュされてしまう
                    if (data === undefined && opts === undefined) {
                        return [2 /*return*/, swr.mutate()];
                    }
                    return [2 /*return*/, swr.mutate(data, opts)];
            }
        });
    }); }, [removeCacheOfSamePath, swr]);
    return __assign(__assign({}, swr), { mutate: mutate, removeCacheOfSamePath: removeCacheOfSamePath });
}
//# sourceMappingURL=useAspidaSWR.js.map